export enum RelatedEntitiesResult {
	KnowledgeDiscoveryRelatedEntityConnection = 'KnowledgeDiscoveryRelatedEntityConnection',
	QueryError = 'QueryError',
}
